import { Divider, Theme, Typography, styled } from '@material-ui/core';
import theme from 'src/config/theme';

export const SidepanelDifferentiationTitle = styled(Typography)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const SidepanelDifferentiationDivider = styled(Divider)<Theme>(({ theme }) => ({
  height: 5,
  background: theme.palette.grey[300],
  marginBottom: theme.spacing(4),
}));

export const style = {
  width: '100%',
  border: 'solid 1px #ddd',
  background: theme.palette.common.white,
  position: 'absolute',
  top: 0,
  right: '-100vw',
  zIndex: 1200,
  borderBottom: '0px',
  borderTop: '0px',
} as const;

export const Handler = styled('div')<Theme>(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100vh',
  width: theme.config.sidePanelScroolWidthRem,
  background: theme.config.appbarColors.borderColor,
}));

export const SidePanelNav = styled('div')<Theme, { width?: string | number }>(
  ({ theme, width }) => ({
    width,
    minWidth: 320,
  })
);

export const SidepanelHeader = styled('div')<
  Theme,
  { width?: string | number; presentationmode: boolean }
>(({ theme, width, presentationmode }) => ({
  background: theme.palette.white,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: presentationmode ? theme.config.subHeaderHeight : theme.config.appbarHeight,
  width,
  minWidth: 320,
  borderBottom: theme.config.appbarColors.borderColor,
  padding: theme.spacing(2),
  '& > h2': {
    fontSize: 16,
  },
}));

export const SidepanelNavBar = styled('div')<Theme, { width?: string | number }>(
  ({ theme, width }) => ({
    height: theme.config.subHeaderHeightPx,
    minHeight: theme.config.subHeaderHeightPx,
    background: theme.palette.white,
    width,
    minWidth: 320,
    borderBottom: `1px solid ${theme.config.appbarColors.borderColor}`,
  })
);

export const SidepanelContentWrapper = styled('div')<Theme, { width?: string | number }>(
  ({ theme, width }) => ({
    width,
    minWidth: 320,
    height: `calc(100% - ${theme.config.subHeaderHeightPx} - ${theme.config.appbarHeightPx})`,
    overflowY: 'auto',
    overflowX: 'hidden',
  })
);
